function RegisterPage({
  displayName,
  email,
  error,
  isSubmitting,
  onDisplayNameChange,
  onEmailChange,
  onPasswordChange,
  onRegister,
  password,
  switchToLogin,
}) {
  return (
    <section className="main-panel">
      <div className="login-layout">
        <form className="auth-card" onSubmit={onRegister}>
          <span className="mini-label">Opret konto</span>
          <h1>Kom i gang med Annoncen</h1>
          <p>Opret en konto til både køb og salg, så dine annoncer og favoritter følger dig.</p>

          <label>
            Navn
            <input
              autoComplete="name"
              onChange={(event) => onDisplayNameChange(event.target.value)}
              placeholder="Emma Nielsen"
              type="text"
              value={displayName}
            />
          </label>

          <label>
            Email
            <input
              autoComplete="email"
              onChange={(event) => onEmailChange(event.target.value)}
              placeholder="emma@example.com"
              type="email"
              value={email}
            />
          </label>

          <label>
            Password
            <input
              autoComplete="new-password"
              onChange={(event) => onPasswordChange(event.target.value)}
              placeholder="Mindst 8 tegn"
              type="password"
              value={password}
            />
          </label>

          <button className="primary-action" type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Opretter..." : "Opret konto"}
          </button>

          <button className="text-action" onClick={switchToLogin} type="button">
            Jeg har allerede en konto
          </button>

          {error && <p className="status-line error">{error}</p>}
        </form>
      </div>
    </section>
  );
}

export default RegisterPage;
